import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon, ClockIcon } from 'lucide-react';
import { useQuoteModal } from '../contexts/QuoteModalContext';
import { QuoteForm } from './QuoteForm';
export function QuoteModal() {
  const {
    isOpen,
    closeQuote
  } = useQuoteModal();
  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') closeQuote();
    };
    window.addEventListener('keydown', onKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen, closeQuote]);
  return <AnimatePresence data-id="element-281" data-mp="btcjtw0mmtr7">
      {isOpen && <div className="fixed inset-0 z-50 flex items-end justify-center sm:items-center sm:p-6" data-id="element-282" data-mp="bsl0pko7uoht">
          <motion.div className="absolute inset-0 bg-ink-900/70" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} onClick={closeQuote} aria-hidden="true" data-id="element-283" data-mp="gr4o7pigk8ca" />

          <motion.div role="dialog" aria-modal="true" aria-labelledby="quote-modal-title" initial={{
        opacity: 0,
        y: 28,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.98
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative flex max-h-[92vh] w-full max-w-2xl flex-col overflow-hidden rounded-t-lg bg-white shadow-2xl sm:rounded-lg" data-id="element-284" data-mp="3fce04r23asxe">
            <header className="flex items-start justify-between gap-4 bg-forest-800 px-6 py-5 sm:px-8" data-id="element-285" data-mp="2riw5u8plo8es">
              <div data-id="element-286" data-mp="pp6mhgh328af">
                <p className="font-display text-xs uppercase tracking-[0.2em] text-ember-500" data-id="element-287" data-mp="pon5q3365pxz">
                  Free quote — no obligation
                </p>
                <h2 id="quote-modal-title" className="mt-1 font-display text-2xl uppercase leading-tight text-white" data-id="element-288" data-mp="18roxw9vj1pu4">
                  Tell us what needs to go
                </h2>
                <p className="mt-1 flex items-center gap-2 text-sm text-white/70" data-id="element-289" data-mp="14roj2o4incmj">
                  <ClockIcon className="h-4 w-4 text-ember-500" aria-hidden="true" data-id="element-290" data-mp="1shsl4r2234bf" />
                  Takes under a minute — Javier calls you back
                </p>
              </div>
              <button type="button" onClick={closeQuote} aria-label="Close quote form" className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md border border-white/20 text-white transition-colors duration-150 ease-out hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-ember-500" data-id="element-291" data-mp="1wh1ehut6p06g">
                <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-292" data-mp="c169d49aed05" />
              </button>
            </header>

            <div className="overflow-y-auto" data-id="element-293" data-mp="3vqb2qogb2wmz">
              <QuoteForm data-id="element-294" data-mp="3vpj5zaaz2sv4" />
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}